import { createContext, useState, useContext, useEffect } from "react";
import { registerSetLoading } from "../api/loadingBridge"; // path to loadingBridge

const LoadingContext = createContext<{ isLoading: boolean; setLoading: (val: boolean) => void } | undefined>(undefined);

export const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        registerSetLoading(setIsLoading);
    }, []);

    return (
        <LoadingContext.Provider value={{ isLoading, setLoading: setIsLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const ctx = useContext(LoadingContext);
    if (!ctx) throw new Error("useLoading must be used inside LoadingProvider");
    return ctx;
};
